export const GAME_FIELDS = [
    'allow_freespins',
    'bonus_no_play',
    'loyalty_allowed',
    'rollover_allowed',
];
